// =============================================================================
// Generic loading throbber component. See src/shared/util/OkLoader for the real
// heavy lifting. You can either pass this thing a "show" prop to determine if
// it should spin or not, or directly call "start" and "stop" functions on it.
// -----------------------------------------------------------------------------

import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import OkLoader from "shared/util/OkLoader";

class OkLoaderComponent extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		show: PropTypes.bool,
		size: PropTypes.oneOf([
			"tiny",
			"xsmall",
			"small",
			"medium",
			"large",
		]),
		color: PropTypes.string,
		fade: PropTypes.number,
		top: PropTypes.node,
		left: PropTypes.node,
	};

	componentDidMount() {
		this.okloader = new OkLoader(this.el, {
			size: this.props.size,
			color: this.props.color,
			fade: this.props.fade,
			top: this.props.top,
			left: this.props.left,
		});
		this._startOrStop();
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.show !== nextProps.show) {
			this._startOrStop(nextProps.show);
		}
	}

	// No need to cache in state, doesn't affect render function.
	okloader = null;

	_startOrStop = (newShow) => {
		if (!this.okloader) {
			return;
		}

		const show = newShow !== null && newShow !== undefined ? newShow : this.props.show;

		if (show) {
			this.okloader.start();
		} else {
			this.okloader.stop();
		}
	};

	render() {
		const classes = classnames("okloader", this.props.className);
		const style = {
			pointerEvents: "none",
		};

		return <div className={classes} style={style} ref={(el) => { this.el = el; }} />;
	}
}

export default OkLoaderComponent;



// WEBPACK FOOTER //
// ./src/shared/components/OkLoader.jsx